<template>
  <div class="timebar page_text_font">
    <div class="barBg">
      <span
        class="barBgLength"
        :style="{ width: (trackStateCount / 6) * 100 + '%' }"
      ></span>
    </div>
    <div
      class="trackItem trackItem1"
      :class="trackStateCount > 0 ? 'arriver' : ''"
    >
      <div class="tips">
        <div class="tipsIcon"></div>
        <div> {{$t('track.ordered')}} </div>
        <div>{{ timebar.Ordered }}</div>
      </div>
    </div>
    <div
      class="trackItem trackItem2"
      :class="trackStateCount > 1 ? 'arriver' : ''"
    >
      <div class="tips">
        <div class="tipsIcon"></div>
        <div>{{$t('track.in_process')}}</div>
        <div>{{ timebar.InProcess }}</div>
      </div>
    </div>
    <div
      class="trackItem trackItem3"
      :class="trackStateCount > 2 ? 'arriver' : ''"
    >
      <div class="tips">
        <div class="tipsIcon"></div>

        <div>{{$t('track.order_ready')}}</div>
        <div>{{ timebar.OrderReady }}</div>
      </div>
    </div>
    <div
      class="trackItem trackItem4"
      :class="trackStateCount > 3 ? 'arriver' : ''"
    >
      <div class="tips">
        <div class="tipsIcon"></div>
        <div>{{$t('track.in_transit')}}</div>
        <div>{{ timebar.InTransit }}</div>
      </div>
    </div>
    <div
      class="trackItem trackItem5"
      :class="trackStateCount > 4 ? 'arriver' : ''"
    >
      <div class="tips">
        <div class="tipsIcon"></div>

        <div>{{$t('track.out_for_delivery')}}</div>
        <div>{{ timebar.OutForDelivery }}</div>
      </div>
    </div>
    <div
      class="trackItem trackItem6"
      :class="trackStateCount > 5 ? 'arriver' : ''"
    >
      <div class="tips">
        <div class="tipsIcon"></div>
        <div>{{$t('track.delivered')}}</div>
        <div>{{ timebar.Delivered }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["timebar"],
  computed: {
    trackStateCount() {
      let timebarList = Object.values(this.timebar).reverse();
      let length = timebarList.length;
      //状态倒序，如果最后一个状态有时间，则timebar长度为最长，否则减1直到有时间
      timebarList.some((item) => {
        if (item) {
          return true;
        } else {
          length--;
        }
      });
      return length;
    },
  },
};
</script>
<style scoped lang='scss'>
* {
  text-align: left;
}
ul {
  li {
    list-style: none;
  }
}
.timebar {
  position: relative;
  padding: 60px 0 100px;
  margin-right: 25px;
  .barBg {
    width: 100%;
    height: 8px;
    position: absolute;
    background-color: #c6c6c6;
    left: 0;
    .barBgLength {
      background: green;
      width: 0%;
      display: inline-block;
      height: 8px;
      position: absolute;
      left: 0;
    }
  }
  .trackItem {
    position: absolute;
    top: 55px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-left: -1px;
    background: #c6c6c6;
    font-size: 77%;
    .tips {
      position: absolute;
      top: 24px;
      min-width: 100px;
      .tipsIcon {
        position: absolute;
        top: -75px;
        height: 40px;
        width: 40px;
        left: 0;
        background-size: 127px 86.4px;
        background-image: url("~@/images/track.png");
      }
    }
    &:last-child {
      .tips {
        img {
          left: -18px;
        }
      }
    }
  }
  .arriver {
    background-color: green !important;
  }
  .trackItem1 {
    left: 0;
    .tips {
      .tipsIcon {
        background-position: 0px 0px;
        background-size: 108px 86.4px;
      }
    }
  }
  .trackItem2 {
    left: 20%;
    .tips {
      .tipsIcon {
        background-position: -87px 0px;
      }
    }
  }
  .trackItem3 {
    left: 40%;
    .tips {
      .tipsIcon {
        background-position: -40px -40px;
      }
    }
  }
  .trackItem4 {
    left: 60%;
    .tips {
      .tipsIcon {
        background-position: -87px -40px;
      }
    }
  }
  .trackItem5 {
    left: 80%;
    .tips {
      .tipsIcon {
        background-position: -0 -40px;
      }
    }
  }
  .trackItem6 {
    left: 100%;
    .tips {
      .tipsIcon {
        background-position: -47px -0;
      }
    }
  }
}
</style>